import React from "react";

import { channelLabel, metadata } from "../../campaignUtils";
import { Chip, EmptyState, HelpTip, Pages, StatusPill } from "../../shared/StudioControls";

export const DeliveryHistory = ({ counts, logs, isBusy, onLogsPage }) => (
  <div className="cs-history">
    <p className="cs-muted">
      Test notifications and customer notifications
      <HelpTip label="About this history" points="“Submitted” means the provider accepted the message, not that it was delivered" />
    </p>
    {counts.length > 0 && (
      <ul className="cs-chip-row" aria-label="Totals by status">
        {counts.map(row => <li key={row.status}><Chip>{row.status}: {row.total}</Chip></li>)}
      </ul>
    )}
    {logs && logs.data.length === 0 && <EmptyState title="No tests or sends yet" />}
    {logs && logs.data.length > 0 && (
      <div className="cs-table-wrap" tabIndex={0} role="region" aria-label="Test and send history">
        <table className="cs-table">
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">Channel</th>
              <th scope="col">Recipient</th>
              <th scope="col">Status</th>
              <th scope="col">Revision</th>
              <th scope="col">Recorded</th>
              <th scope="col">Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.data.map(log => {
              const meta = metadata(log);
              return (
                <tr key={log.id}>
                  <td>{meta.test ? "Test notification" : "Customer notification"}</td>
                  <td>{channelLabel(log.channel)}</td>
                  <td>{log.recipient}</td>
                  <td><StatusPill status={log.status} /></td>
                  <td>{meta.revision == null ? "—" : meta.revision}</td>
                  <td>{log.created_at || "—"}</td>
                  <td>{log.error_message || meta.reason || "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
    <Pages data={logs} disabled={isBusy} onPage={onLogsPage} label="History pages" />
  </div>
);
